module.exports = __webpack_public_path__ + "img/not-found.3d1be51.png";